<template>
  <div :class="wrpCls">
    <a-space size="middle">
      <!-- 敏感信息脱敏开关（手机号 / 身份证 / 银行卡 / 营业执照等） -->
      <a-popover trigger="click" placement="bottomRight" overlayClassName="sensitive-popover">
        <template slot="content">
          <div style="width: 240px">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px">
              <span>敏感信息脱敏</span>
              <a-switch size="small" :checked="sensitiveHidden" :disabled="sensitiveLocked" @change="onSensitiveChange" />
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center">
              <span>脱敏方式</span>
              <a-radio-group
                size="small"
                button-style="solid"
                :value="sensitiveMode"
                :disabled="!sensitiveHidden || sensitiveLocked"
                @change="onModeChange"
              >
                <a-radio-button value="mask">打码</a-radio-button>
                <a-radio-button value="hide">隐藏</a-radio-button>
              </a-radio-group>
            </div>
            <div style="margin-top: 10px; font-size: 12px; color: #faad14; line-height: 18px">
              开启后手机号、身份证、银行卡、营业执照等不再明文展示；切换后自动刷新页面生效。脱敏期间请勿编辑保存含敏感信息的表单。
            </div>
            <div v-if="sensitiveLocked" style="margin-top: 6px; font-size: 12px; color: rgba(0, 0, 0, .45); line-height: 18px">
              当前由「参数设置 sys.sensitive.hidden」强制开启，如需关闭请到后台参数设置中修改。
            </div>
          </div>
        </template>
        <a-tooltip>
          <template slot="title">
            {{ sensitiveHidden ? (sensitiveLocked ? '敏感信息脱敏已开启（参数设置锁定）' : '敏感信息脱敏已开启（点击查看/设置）') : '敏感信息脱敏已关闭（点击查看/设置）' }}
          </template>
          <a-icon
            class="sensitive-toggle"
            :type="sensitiveHidden ? 'eye-invisible' : 'eye'"
            :style="{ fontSize: '17px', cursor: 'pointer', color: sensitiveHidden ? '#52c41a' : '' }"
          />
        </a-tooltip>
      </a-popover>
      <screenfull />
      <notice-icon v-hasPermi="['system:notice:list']" style="cursor: pointer;"/>
      <avatar-dropdown :menu="showMenu" :current-user="currentUser" :class="prefixCls" />
      <select-lang v-if="openLangListLength>0" :class="prefixCls" />
    </a-space>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AvatarDropdown from './AvatarDropdown'
import NoticeIcon from '@/components/NoticeIcon'
import Screenfull from '@/components/Screenfull'
import SelectLang from '@/components/SelectLang'
import { SENSITIVE_HIDDEN, SENSITIVE_MODE } from '@/store/mutation-types'

export default {
  name: 'RightContent',
  components: {
    AvatarDropdown,
    NoticeIcon,
    Screenfull,
    SelectLang
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ant-pro-global-header-index-action'
    },
    isMobile: {
      type: Boolean,
      default: () => false
    },
    topMenu: {
      type: Boolean,
      required: true
    },
    theme: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      openLangListLength:0,
      showMenu: true,
      currentUser: {},
      docUrl: process.env.VUE_APP_BASE_API +'/doc',
      githubUrl: 'http://gitlab.niurenjianzhan.com/zhangxun/java-framework'
    }
  },
  computed: {
    ...mapState({
      sensitiveHidden: state => state.app.sensitiveHidden,
      sensitiveMode: state => state.app.sensitiveMode,
      sensitiveLocked: state => state.app.sensitiveLocked
    }),
    wrpCls () {
      return {
        'ant-pro-global-header-index-right': true,
        [`ant-pro-global-header-index-${(this.isMobile || !this.topMenu) ? 'light' : this.theme}`]: true
      }
    }
  },
  mounted () {
   this.openLangListLength =  globalThis.$openLangList.length;
    setTimeout(() => {
      this.currentUser = {
        name: 'RuoYi'
      }
    }, 1500)
  },
  methods: {
    // 敏感信息脱敏开关：作用于接口响应阶段，切换后刷新页面生效
    onSensitiveChange (checked) {
      if (this.sensitiveLocked) {
        this.$message.warning('已由参数设置（sys.sensitive.hidden）强制开启，请到后台参数设置中修改')
        return
      }
      this.$store.commit(SENSITIVE_HIDDEN, checked === true)
      this.$message.success(checked ? '敏感信息脱敏已开启，正在刷新页面' : '敏感信息脱敏已关闭，正在刷新页面')
      setTimeout(() => {
        window.location.reload()
      }, 500)
    },
    onModeChange (e) {
      const value = e.target.value
      this.$store.commit(SENSITIVE_MODE, value)
      this.$message.success(value === 'hide' ? '已切换为隐藏（******）' : '已切换为打码（138****5678）')
      setTimeout(() => {
        window.location.reload()
      }, 500)
    },
    toDoc () {
      window.open(this.docUrl)
    },
    toGithub () {
      window.open(this.githubUrl)
    }
  }
}
</script>
